"use strict";
var React = require("react");
var LinkedStateMixin = require("react-addons-linked-state-mixin");
var { Modal, Button, ButtonToolbar, closeButton } = require("react-bootstrap");
var CompanyActions = require("../../../actions/CompanyActions");
var {
    Input
} = require("react-bootstrap");

var EditPasswordModal = React.createClass({
    mixins: [LinkedStateMixin],
    getInitialState: function() {
        return {
            id: this.props.user && this.props.user.id || "",
            password: "",
            password_confirm: "",
            first_name: this.props.user && this.props.user.first_name || "",
            last_name: this.props.user && this.props.user.last_name || "",
            email: this.props.user && this.props.user.email || "",
            is_active: this.props.user && this.props.user.is_active || false,
            home_department: this.props.user && this.props.user.home_department || "",
            show_warning: true
        };
    },
    onSubmit(event) {
        if (this.state.password === this.state.password_confirm) {
            this.props.onHide();
            event.preventDefault();

            var newUserInfo = {
                "first_name": this.state.first_name,
                "last_name": this.state.last_name,
                "email": this.state.email,
                "is_active": this.state.is_active,
                "home_department": this.state.home_department,
                "password": this.state.password
            };
            CompanyActions.updateUser({id: this.state.id, body: newUserInfo});
        } else {
            this.setState({show_warning: false});
        }
    },
    render: function() {
        return (
            <Modal id="addLoctionModal" {...this.props} bsStyle='primary' animation={true}>
                <Modal.Header closeButton>
                     <Modal.Title>Breyta lykilorði</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Input
                        label="Lykilorð"
                        type="password"
                        placeholder="Sláðu inn lykilorð"
                        valueLink={this.linkState("password")}
                    />
                    <Input
                        label="Staðfesta lykilorð"
                        type="password"
                        placeholder="Sláðu inn lykilorð"
                        valueLink={this.linkState("password_confirm")}
                    />
                    {this.state.show_warning === false ? <span className="warning text">Lykilorð passa ekki saman!</span> : null}
                </Modal.Body>
                <Modal.Footer>
                    <ButtonToolbar>
                        <Button className="btn-success" onClick={this.onSubmit} type='submit'>Vista <i className="glyphicon glyphicon-ok"></i></Button>
                        <Button onClick={this.props.onHide}>Hætta við</Button>
                    </ButtonToolbar>
                </Modal.Footer>
            </Modal>
        );
    }
});

module.exports = EditPasswordModal;



// WEBPACK FOOTER //
// ./app/scripts/ui/Settings/Users/EditPasswordModal.js